import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, LibraryBigIcon } from 'lucide-react';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-cream py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-125" data-mp="1iw32ha07833a">
      <div className="mx-auto max-w-6xl px-4" data-id="element-126" data-mp="1dxjkfkoq7bg7">
        <div className="text-center" data-id="element-127" data-mp="1dunlpu520iqp">
          <span className="inline-flex items-center gap-2 rounded-md bg-forest-800 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-gold-300" data-id="element-128" data-mp="2bkiedno1a5ae">
            <LibraryBigIcon className="h-4 w-4" aria-hidden="true" data-id="element-129" data-mp="26jb5tme2h22o" /> Material completo para el aula
          </span>
          <h2 id="modules-title" className="mt-4 text-3xl font-extrabold text-forest-950 sm:text-4xl" data-id="element-130" data-mp="1wn86eoalnhjf">
            Los {totalVolumes} tomos del Megapack
          </h2>
        </div>

        <div className="mt-10 grid gap-6 lg:grid-cols-2" data-id="element-131" data-mp="q4jivozown0r">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.1
          }} transition={{
            duration: 0.3,
            delay: index % 2 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col overflow-hidden rounded-xl border border-earth-200 bg-white shadow-sm shadow-earth-900/5" data-id="element-132" data-mp="1ivry2jrcuz3q" data-mpi={index}>
                <div className="flex min-h-[104px] items-center gap-4 bg-forest-900 px-6 py-5" data-id="element-133" data-mp="14vpix5afmjs6">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-md bg-gold-500 text-forest-950" data-id="element-134" data-mp="q7cmk77fmyx5">
                    <Icon className="h-6 w-6" aria-hidden="true" data-id="element-135" data-mp="v6601zmpypxb" />
                  </span>
                  <div data-id="element-136" data-mp="h76amprdu703">
                    <p className="text-[11px] font-extrabold uppercase tracking-[.18em] text-gold-300" data-id="element-137" data-mp="h7zmu6941opm">
                      Tomo {module.number}
                    </p>
                    <h3 className="mt-1 text-lg font-extrabold leading-tight text-cream" data-id="element-138" data-mp="2nux9xqs6mcu2">{module.title}</h3>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6" data-id="element-139" data-mp="2e4c3jh69o40l">
                  <p className="font-semibold text-earth-800" data-id="element-140" data-mp="2e4vhkmssq89c">{module.subtitle}</p>

                  <p className="mt-5 text-[11px] font-extrabold uppercase tracking-[.16em] text-earth-500" data-id="element-141" data-mp="296k9ohm2a7tr">
                    ¿Qué resuelve en el aula?
                  </p>
                  <p className="mt-2 text-sm leading-relaxed text-earth-700" data-id="element-142" data-mp="31tepv2buil1f">{module.classroom}</p>

                  <ul className="mt-5 grid flex-1 content-start gap-2" data-id="element-143" data-mp="2wu26wso3hy44">
                    {module.items.map(item => <li key={item} className="flex gap-2.5 text-sm leading-snug text-forest-950" data-id="element-144" data-mp="2ssgnspkywnlh">
                        <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-forest-700" aria-hidden="true" data-id="element-145" data-mp="1lgg6gbcsca3a" />
                        {item}
                      </li>)}
                  </ul>

                  <p className="mt-6 rounded-lg border-l-4 border-gold-500 bg-forest-50 p-4 text-sm leading-relaxed text-earth-900" data-id="element-146" data-mp="3t2zuorc26fcn">
                    <b className="font-extrabold text-forest-900" data-id="element-147" data-mp="5wpbkptcw7x4">Resultado: </b>
                    {module.result}
                  </p>
                </div>
              </motion.article>;
        })}
        </div>

        <div className="mt-8 flex flex-col items-center justify-between gap-4 rounded-xl bg-earth-800 px-6 py-6 text-center sm:flex-row sm:text-left" data-id="element-148" data-mp="fnblc3ee647w">
          <p className="text-xs font-extrabold uppercase tracking-[.18em] text-gold-300" data-id="element-149" data-mp="knpu5nnthi6z">Colección principal</p>
          <p className="font-display text-2xl font-extrabold tracking-tight text-cream sm:text-3xl" data-id="element-150" data-mp="oldvp9k0m97u">
            {totalVolumes} tomos premium <span className="mx-2 text-earth-300" data-id="element-151" data-mp="2qf3fu40cwdd9">·</span> Contenido actualizado 2026
          </p>
        </div>
      </div>
    </section>;
}